import React from "react";
import { useIntl } from "react-intl";
import { Check } from "@piiqtechnologies/svg-icons";
import { PeekDivider, PeekGrid, PeekPaper, PeekTypography } from "@piiqtechnologies/ui-components";
import { getReportDescriptionText } from "./constants";
export const ReportDescription = () => {
    const intl = useIntl();
    const reportDescriptionText = getReportDescriptionText(intl);
    const renderRowValue = (value) => {
        if (typeof value === "boolean") {
            return value ? (React.createElement(PeekTypography, { variant: "h3", color: "secondary.main", sx: { justifySelf: "center" } },
                React.createElement(Check, null))) : (React.createElement(PeekTypography, { color: "grey.200", variant: "h4", textAlign: "center" }, "\u2014"));
        }
        return (React.createElement(PeekTypography, { variant: "h4", textAlign: "center" }, value));
    };
    return (React.createElement(PeekPaper, { elevation: 1, sx: { width: "100%", px: 3, py: 1, overflowX: { xs: "auto", md: "visible" } } },
        React.createElement(PeekGrid, { container: true, py: 1.5, px: 1.5, textAlign: "left", minWidth: { xs: 700, md: "100%" } },
            React.createElement(PeekGrid, { xs: 4.5 },
                React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightMedium" }, reportDescriptionText.featuresColumnTitle)),
            React.createElement(PeekGrid, { xs: 2.5 },
                React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightMedium", textAlign: "center" }, reportDescriptionText.planTitles.basic)),
            React.createElement(PeekGrid, { xs: 2.5 },
                React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightMedium", textAlign: "center", color: "secondary.main" }, reportDescriptionText.planTitles.premium)),
            React.createElement(PeekGrid, { xs: 2.5 },
                React.createElement(PeekTypography, { variant: "h3", fontWeight: "fontWeightMedium", textAlign: "center" }, reportDescriptionText.planTitles.enterprise))),
        React.createElement(PeekDivider, { light: true }),
        reportDescriptionText.rows.map((row, index) => (React.createElement(React.Fragment, { key: row.id },
            React.createElement(PeekGrid, { container: true, py: 1.5, px: 1.5, textAlign: "left", minWidth: { xs: 700, md: "100%" } },
                React.createElement(PeekGrid, { xs: 4.5 },
                    React.createElement(PeekTypography, { variant: "h4" }, row.label)),
                React.createElement(PeekGrid, { xs: 2.5 }, renderRowValue(row.values.basic)),
                React.createElement(PeekGrid, { xs: 2.5 }, renderRowValue(row.values.premium)),
                React.createElement(PeekGrid, { xs: 2.5 }, renderRowValue(row.values.enterprise))),
            index < reportDescriptionText.rows.length - 1 && React.createElement(PeekDivider, { light: true }))))));
};
export default ReportDescription;
